import './Skeleton.5aa2c297af625c74d83b69846e7bf0dc.css';
export default {"skeleton":"_skeleton_1va3x_1","animated":"_animated_1va3x_1"};